import { reactive, readonly } from "vue";

const state = reactive({ items: [] });
export const toasts = readonly(state);

let nextId = 1;

/** Announced to assistive technology as well as shown, so it is not silent. */
export function notify(message, tone = "good", timeout = 4200) {
  const id = nextId++;
  state.items.push({ id, message, tone });
  const live = document.querySelector("[data-live-region]");
  if (live) live.textContent = message;
  window.setTimeout(() => {
    const index = state.items.findIndex((item) => item.id === id);
    if (index !== -1) state.items.splice(index, 1);
  }, timeout);
  return id;
}
